export default __webpack_public_path__ + "static/media/330_dummy2016-diy01-mobile-de.e10edfb5.png";